import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { TippyV2 } from "@/react/components/shared/TippyV2";
import { Button } from "@circle-react-uikit/Button";

export const FileButtons = ({
  url,
  onDelete,
}: {
  url: string;
  onDelete: () => void;
}) => (
  <div className="text-dark flex gap-3">
    <TippyV2
      arrow={false}
      content={t(
        "settings.community_bot.knowledge.custom.preview_drawer.download",
      )}
    >
      <Button
        variant="secondary-light"
        className="inline !p-1.5"
        onClick={event => {
          window.open(url, "_blank");
          event.stopPropagation();
          event.preventDefault();
        }}
      >
        <Icon size={20} type="20-snippet-preview-arrow-box" />
      </Button>
    </TippyV2>
    <TippyV2
      arrow={false}
      content={t(
        "settings.community_bot.knowledge.custom.preview_drawer.delete",
      )}
    >
      <Button
        variant="secondary-light"
        className="inline !p-1.5"
        onClick={event => {
          onDelete();
          event.stopPropagation();
          event.preventDefault();
        }}
      >
        <Icon size={20} type="20-snippet-preview-trash" />
      </Button>
    </TippyV2>
  </div>
);
